module.exports = __webpack_public_path__ + "img/Cygnus.b5122e97.png";